import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './components/Home/Home'
import Header from './components/Layout/Header/Header'
import Footer from './components/Layout/Footer/Footer'
import AuthGuard from './components/Guards/GuardAuth';
import UserRoutes from "./components/Sections/UserRoutes/UserRoutes";
import AddUser from './components/Layout/AddUser/AddUser';
import DownloadApp from './components/Layout/App/DownloadApp'
import NotFound from './components/Layout/404/NotFound'

const Router = () => {
    return (
        <BrowserRouter>
            <Header />
            <Routes>
                <Route
                    path="/"
                    element={
                        <AuthGuard>
                            <Home />
                        </AuthGuard>
                    }
                />
                <Route
                    path="/usuario/:username"
                    element={
                        <AuthGuard>
                            <UserRoutes />
                        </AuthGuard>
                    }
                />
                <Route
                    path="/adduser"
                    element={
                        <AuthGuard>
                            <AddUser />
                        </AuthGuard>
                    }
                />
                <Route
                    path="/dowloadapp/qualityroute/app/apk"
                    element={
                        <DownloadApp />
                    }
                />
                <Route
                    path="*"
                    element={
                        <NotFound />
                    }
                />
            </Routes>
            <Footer />
        </BrowserRouter>
    )
}

export default Router;
